import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    panelRoot: {
      width: '100%'
    },
    statInline: {
      display: 'inline-flex',
      alignItems: 'center' as const,
      gap: 4
    },
    statInlineLabel: {
      fontSize: 10,
      textTransform: 'uppercase' as const,
      letterSpacing: '0.04em',
      color: token.colorTextSecondary
    },
    statInlineValue: {
      fontSize: 13,
      fontVariantNumeric: 'tabular-nums' as const,
      fontWeight: 600,
      color: token.colorText
    },

    providersCard: {},
    providersHeader: {
      padding: `${token.paddingXS}px ${token.padding}px`,
      borderBottom: `1px solid ${token.colorBorderSecondary}`
    },
    groupHeader: {
      padding: `${token.paddingXXS}px ${token.padding}px`,
      background: token.colorFillAlter,
      borderBottom: `1px solid ${token.colorBorderSecondary}`,
      fontSize: 11,
      fontWeight: 600,
      color: token.colorTextSecondary,
      textTransform: 'uppercase' as const,
      letterSpacing: '0.04em'
    },
    providerRow: {
      padding: `${token.paddingSM}px ${token.padding}px`,
      borderBottom: `1px solid ${token.colorSplit}`
    },
    providerRowLast: {
      borderBottom: 'none'
    },
    providerRowSoon: {
      opacity: 0.65
    },
    providerIcon: {
      width: 34,
      height: 34,
      borderRadius: 8,
      display: 'inline-flex',
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      flex: '0 0 auto',
      fontSize: 16
    },
    protocolTag: {
      marginInlineEnd: 0,
      fontSize: 10,
      lineHeight: '16px',
      background: token.colorFillTertiary,
      color: token.colorTextSecondary,
      border: 'none',
      fontFamily: 'JetBrains Mono, ui-monospace, SFMono-Regular, monospace'
    },
    soonTag: {
      marginInlineEnd: 0,
      fontSize: 10,
      lineHeight: '16px',
      background: token.colorWarningBg,
      color: token.colorWarning,
      border: 'none'
    },
    attentionTag: {
      marginInlineEnd: 0,
      fontSize: 10,
      lineHeight: '16px',
      background: token.colorErrorBg,
      color: token.colorError,
      border: 'none',
      display: 'inline-flex',
      alignItems: 'center' as const
    },
    credentialsPanel: {
      marginTop: token.marginSM,
      padding: token.paddingSM,
      borderRadius: token.borderRadiusLG,
      border: `1px dashed ${token.colorBorderSecondary}`,
      background: token.colorFillAlter
    },
    setupBlock: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: token.marginXS,
      padding: token.paddingSM,
      borderRadius: token.borderRadiusLG,
      border: `1px solid ${token.colorBorderSecondary}`,
      background: token.colorFillAlter
    },
    setupSubBlock: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: token.marginXXS
    },

    settingsCard: {},
    settingRow: {
      padding: `${token.paddingSM}px ${token.padding}px`
    },
    settingIcon: {
      width: 30,
      height: 30,
      borderRadius: 7,
      display: 'inline-flex',
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      flex: '0 0 auto',
      fontSize: 14
    },

    callbackRow: {
      padding: `6px ${token.paddingSM}px`,
      background: token.colorFillAlter,
      border: `1px solid ${token.colorBorderSecondary}`,
      borderRadius: token.borderRadiusSM
    },
    callbackLabel: {
      fontSize: 10,
      textTransform: 'uppercase' as const,
      letterSpacing: '0.04em',
      color: token.colorTextSecondary,
      display: 'block' as const,
      marginBottom: 2
    },

    sectionLabel: {
      fontSize: 11,
      fontWeight: 600,
      color: token.colorTextSecondary,
      textTransform: 'uppercase' as const,
      letterSpacing: '0.05em',
      display: 'block' as const,
      margin: '10px 0 8px'
    },
    advancedCollapse: {
      marginBottom: token.margin,
      '& .ant-collapse-header': {
        paddingInline: '0 !important',
        fontSize: 12,
        color: token.colorTextSecondary
      },
      '& .ant-collapse-content-box': {
        paddingInline: '0 !important',
        paddingTop: '8px !important'
      }
    }
  }
})
